module.exports = __webpack_public_path__ + "static/uni_howard-5a8e631c873c025af336707fd307b495.png";